import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  List,
  ListItem,
  useMediaQuery,
  useTheme,
  Stack
} from '@mui/material';

const SpecificationSection = ({ specs }) => {
  const [showAll, setShowAll] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const visibleSpecs = showAll ? specs : specs.slice(0, 4);

  return (
    <Box sx={{ backgroundColor: '#E3F0FF', py: 4, px: { xs: 2, sm: 4, md: 6 } }}>
    
   <Stack  direction="row"
  justifyContent="center"
  alignItems="center"
  sx={{ width: '100%', mt: 2, mb: 2 }}>
    <Typography
      variant="h3"
      sx={{
        color: 'black',
        backgroundColor: 'white',
        textAlign:'center',
        width:230,
        marginTop:1,
        marignBottom:2,
        borderRadius:'40px',
        fontSize:'20px',
        padding:2,
      }}
    >
     Product Specification
    </Typography>
    </Stack>


      <Grid container spacing={2} justifyContent="center">
        {visibleSpecs.map((spec, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              sx={{
                borderRadius: 2,
                height: '300px',
                maxHeight:'300px',
                px: 2,
                py: 2,
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    backgroundColor: '#007bff',
                    color: '#fff',
                    width: 28,
                    height: 28,
                    
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    mb: 1,
                  }}
                >
                  {index + 1}
                </Box>
                <Typography
                  variant="h2"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ fontSize: '14px' }}
                >
                  {spec.name}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontSize: '12px', }}
                >
                  {spec.details}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {specs.length > 4 && (
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Button
            variant="outlined"
            sx={{ borderRadius: '20px', px: 4 , borderColor:'#222224',color:'#222224'}}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'SHOW LESS' : 'SHOW MORE'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SpecificationSection;
